<template>
  <div v-if="actionsPage">
    <template v-if="actionsPage.results[0]">
      <div
        v-for="action of actionsPage.results"
        :key="action.id"
        class="actions-card-item"
      >
        <div v-if="action.title" class="actions-card-item-name">
          {{ action.title }}
        </div>
        <div v-else-if="action.type" class="actions-card-item-name">
          {{ action.type.nameHistory }}
        </div>
        <div class="actions-card-item-date">
          <i class="fal fa-calendar-alt"></i
          >{{ $d(new Date(action.createdAt), "long") }} Uhr
        </div>
        <div
          v-if="action.consultant"
          class="actions-card-item-consultant"
          :style="
            getColorByUser(
              action.consultant.firstName,
              action.consultant.lastName
            )
          "
        >
          <span
            :title="
              `${action.consultant.firstName} ${action.consultant.lastName}`
            "
            >{{ getShorthandSymbol(action) }}
          </span>
        </div>
      </div>
    </template>
    <div v-else>Keine Einträge</div>
  </div>
</template>

<script>
import gql from "graphql-tag";
const COMPANY_CONTACT_QUERY = `  companyContact{
    firstName
    lastName
    id
    department
    telephone
    email
    position
  }
`;
const ACTION_PAGE_QUERY = (nameColumn, showCompanyContact) => gql`
  query ActionsPage($page: Int!, $size: Int, $filter: ActionFilter) {
    actionsPage(page: $page, size:$size filter: $filter) {
      results {
        id
        description
        done
        title
        type {
          id
          ${nameColumn}
        }
        project {
          id
          number
          title
        }
        consultant {
          id
          firstName
          lastName
          shorthandSymbol
        }
        automatic
        dueAt
        remindAt
        createdAt
        remindAt${showCompanyContact ? COMPANY_CONTACT_QUERY : ""}
      }
    }
  }
`;

export default {
  props: {
    isHistory: { type: Boolean, default: false },
    type: { type: String, required: true },
    resourceId: { type: String, required: true },
    showCompanyContact: { type: Boolean, default: false }
  },
  data() {
    return {
      fetchFailed: false,
      editing: null,
      selected: "",
      form: {
        description: "",
        done: true,
        refID: null,
        refType: null,
        typeID: null,
        applicantID: null,
        consultantID: null,
        projectID: null,
        dueAt: new Date()
      }
    };
  },
  apollo: {
    actionsPage: {
      query() {
        return ACTION_PAGE_QUERY(this.nameColumn, this.showCompanyContact);
      },
      fetchPolicy: "network-only",
      variables() {
        return {
          page: 1,
          size: 4,
          filter: {
            refType: this.type,
            refID: this.resourceId,
            done: this.isHistory
          }
        };
      }
    },
    me: gql`
      query {
        me {
          id
          consultant {
            id
          }
          group {
            id
          }
        }
      }
    `
  },
  computed: {
    nameColumn() {
      return this.isHistory ? "nameHistory" : "nameResubmission";
    },
    showRemindAt() {
      let result = false;
      for (const entry of this.actionsPage.results) {
        if (entry.remindAt) {
          result = true;
        }
      }
      return result;
    }
  },
  watch: {
    isHistory: {
      immediate: true,
      handler(v) {
        this.form.done = v;
      }
    },
    type: {
      immediate: true,
      handler(v) {
        this.form.refType = v;
      }
    },
    me: {
      handler() {
        this.form.consultantID = this.me.consultant.id;
        this.form.groupID = this.me.group.id;
      }
    }
  },
  methods: {
    //To my best knowledge this is neccessary beacuse Components inside of scoped slots inherit
    //A differnet vue instance on which apollo is not inititalized properly, so the method to make
    //requests has to be injected from the parent component into the child component.
    makeApolloQuery() {
      return (name, options) => {
        this.$apollo.addSmartQuery(name, options);
      };
    },
    getShorthandSymbol(action) {
      if (action.consultant.shorthandSymbol) {
        return action.consultant.shorthandSymbol;
      }

      return (
        action.consultant.firstName.charAt(0) +
        action.consultant.lastName.charAt(0)
      );
    },
    getColorByUser(firstName, lastName) {
      let rgb = {
        r: this.alphabetPosition(firstName.charAt(0)),
        g: this.alphabetPosition(lastName.charAt(0)),
        b: null
      };

      rgb.b = Math.abs(rgb.r - rgb.g);

      return "background-color:rgb(" + rgb.r + "," + rgb.g + "," + rgb.b + ")";
    },
    alphabetPosition(text) {
      let result = "";
      for (let i = 0; i < text.length; i++) {
        const code = text.toUpperCase().charCodeAt(i);
        if (code > 64 && code < 91) result += `${code - 64} `;
      }

      return result.slice(0, result.length - 1) * 10;
    }
  }
};
</script>
